<template>
  <div style="background-color: #fafafa;">
    <van-nav-bar title="红包与转账" left-text="返回" left-arrow @click-left="onClickLeft" :z-index=998 fixed />
    <van-tabs class="tabs" v-model="selected" type="line" sticky @click="switchTab">
      <van-tab title="红包记录"/>
      <van-tab title="转账记录"/>
    </van-tabs>
    <van-search shape="round" v-model="value" placeholder="请输入搜索关键词" show-action @search="onSearch"
                @cancel="onSearch">
      <div slot="action" @click="onSearch">搜索</div>
    </van-search>
    <van-dropdown-menu>
      <van-dropdown-item v-model="sourceValue" :options="source" @change="changeSource"/>
      <van-dropdown-item title="时间" class="dropdownItem" ref="item">
        <div style="display: flex;height:100%;">
          <van-sidebar v-model="activeKey" @change="changeSideBar">
            <van-sidebar-item title="消息时间" />
          </van-sidebar>
          <date-filter v-if="showTime" :time-type="currDateType" @ongetdate="getDate"></date-filter>
        </div>
      </van-dropdown-item>
    </van-dropdown-menu>
    <select-staff :callback="assign" v-model="show"/>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" @load="onLoad" finished-text="没有更多了">
        <div v-for="(clue,index) in list" class="card" :key="clue.uuid">
          <table class="layout">
            <tr>
              <td class="avatar-box" rowspan="4">
                <img :src="clue.customerIcon" class="avatar" alt="avatar">
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <p>
                  <span>联系人名称:</span>
                  <span>{{clue.remark}}</span>
                </p>
                <p>
                  <span>消息内容:</span>
                  <span>{{clue.msgContent}}</span>
                </p>
              </td>
              <td colspan="2" align="right">
                <p>
                  <span>当前微信：</span>
                  <span>{{clue.myWechatNickname}}</span>
                </p>
                <p>
                  <span>发送时间：</span>
                  <span>{{clue.createTime}}</span>
                </p>
              </td>
            </tr>
          </table>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import {Tab, Tabs, Panel, Button, List, Search, Popup,PullRefresh,Toast,NavBar,Tag,Col, Row ,Sidebar, SidebarItem,DatetimePicker,Field,DropdownMenu, DropdownItem, Icon} from 'vant';
import userInfo from '../../../store/userInfo';
import threadService from "../../../service/threadService";
import redAndTransfer from "../../../service/wechat/RedAndTransfer";
import moment from "moment";
import {formatDictionary} from "../../../utils/dictionary";
import {API_URL} from "../../../common/config";
import SelectStaff from "../../../components/SelectStaff";
import dateFilter from '../../../components/dateFilter';

export default {
  data: function () {
    return {
      detailShow:false,
      selected: 0,
      searchParam: {},
      list: [],
      loading: false,
      finished: false,
      pageIndex: 0,
      value: '',
      show: false,
      refreshing: false,
      type: 0,
      clueId:'',
      clue:{},
      showTime: true,
      activeKey: 0,
      contactTime: '',
      beginTime: '',
      endTime: '',
      createTime: '',
      startCreateTime: '',
      finishCreateTime: '',
      currDateType: 0,
      currCreateDateType: 0,
      currDisAdvisorDateType: 0,
      source: [{text:'员工名称',value:0}],
      sourceValue: 0,
      staffId:'',
    }
  },
  store: userInfo,
  components: {
    dateFilter,
    SelectStaff,
    [Tab.name]: Tab,
    [Tag.name]: Tag,
    [NavBar.name]: NavBar,
    [Tabs.name]: Tabs,
    [Button.name]: Button,
    [PullRefresh.name]: PullRefresh,
    [Panel.name]: Panel,
    [List.name]: List,
    [Col.name]: Col,
    [Row.name]: Row,
    [Search.name]: Search,
    [Popup.name]: Popup,
    [Sidebar.name]: Sidebar,
    [SidebarItem.name]: SidebarItem,
    [DatetimePicker.name]: DatetimePicker,
    [Field.name]: Field,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem .name]: DropdownItem,
    [Icon .name]: Icon
  },
  computed: {
    userId() {
      return this.$store.getters.getUserId;
    },
    avatarUrl() {
      return API_URL + "/oa/common/attachment/showImage?id=";
    }
  },
  created: async function () {

    let resp = await threadService.getOptions('base_staff');
    if (resp.data.Status === "1") {
      let source = resp.data.Data.map(item => {
        return {text: item.name, value: item.uuid};
      });
      this.source = this.source.concat(source)
    }
    let tabIndex = localStorage.getItem('clueTabIndex');
    if(tabIndex === undefined || tabIndex === null) {
      tabIndex = 0;
      this.selected = 0;
      this.type = 0;
    }else {
      this.selected = parseInt(tabIndex);
      this.type = parseInt(tabIndex);
    }
  },
  methods: {
    changeSideBar() {
      if (this.activeKey == 0) {
        this.currDateType = this.currCreateDateType
      } else {
        this.currDateType = this.currDisAdvisorDateType
      }
      this.showTime = false;
      var _this = this;
      this.$nextTick(function () {
        _this.showTime = true;
      })
    },
    getDate(data) {
      if (this.activeKey == 1) {
        this.beginTime = data.startTime;
        this.endTime = data.endTime;

      } else {
        this.beginTime = data.startTime;
        this.endTime = data.endTime;
      }
      this.$refs.item.toggle();
      this.onSearch();
    },
    changeSource(value) {
      this.searchParam['searchField_dictionary_staffId'] = value;
      this.staffId = value;
      this.onSearch();

    },
    async onLoad() {
      this.pageIndex++;
      let tabIndex = localStorage.getItem('clueTabIndex');
      if (tabIndex === undefined || tabIndex === null) {
        tabIndex = 0;
        this.type = 0;
      } else {
        this.type = parseInt(tabIndex);
      }
      if (this.staffId === ''){
        this.staffId = this.userId;
      }
      let resp;
      if (this.type === 1){
        resp = await redAndTransfer.getTransferList(this.staffId, "", this.beginTime, this.endTime, this.pageIndex, this.value,this.searchParam);
        resp.data.Data.data.forEach(clue => {
          clue.createTime = moment(clue.createTime).format('YYYY-MM-DD HH:mm:ss');
          clue.remark = clue.remark || clue.wechatName;
          clue.advisorId = clue.advisorId === undefined ? clue.creatorId : clue.advisorId;
          clue.msgContent = clue.msgContent + '，金额：' + clue.money;
          clue.myWechatNickname = clue.myWechatNickname;
          clue.customerIcon = clue.customerIcon;
        });
      }else {
        resp = await redAndTransfer.getRedList(this.staffId, "", this.beginTime, this.endTime, this.pageIndex, this.value,this.searchParam);
        resp.data.Data.data.forEach(clue => {
          clue.createTime = moment(clue.createTime).format('YYYY-MM-DD HH:mm:ss');
          clue.remark = clue.remark || clue.wechatName;
          clue.advisorId = clue.advisorId === undefined ? clue.creatorId : clue.advisorId;
          clue.msgContent = clue.msgContent;
          clue.myWechatNickname = clue.myWechatNickname;
          clue.customerIcon = clue.customerIcon;
        });
      }
      formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
      this.loading = false;
      this.refreshing = false;
      formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
      this.list = [...this.list, ...resp.data.Data.data];
      this.finished = resp.data.Data.total <= this.list.length;
    },
    onSearch() {
      this.searchParam['searchField_string_msgContent'] = this.value;
      this.finished = false;
      this.loading = true;
      this.pageIndex = 0;
      this.list = [];
      this.onLoad();
    },
    onRefresh() {
      this.finished = false;
      this.pageIndex = 0;
      this.list = [];
      this.onLoad();
    },
    onClickLeft() {
      window.open('/colseWebView');
    },
    switchTab(tabIndex) {
      localStorage.setItem('clueTabIndex', tabIndex);
      window.scrollTo(0, 0);
      this.type = tabIndex;
      this.value = '';
      this.onSearch();
    },
    async assign(staffId){
      let staffIds = localStorage.getItem("staffIds");
      if (staffIds === undefined || staffIds === null){
        localStorage.setItem("staffIds",staffId);
      }else {
        if (staffIds.split(staffId).length === 1){
          staffIds = staffIds+","+staffId;
          localStorage.setItem("staffIds",staffIds);
        }
      }
    },
  }
};

</script>

<style>
.dropdownItem>.van-dropdown-item>.van-popup {
  max-height: 100%;
  height: 100%;
}
.van-popup--right{
  width:100%;
  height:100%;
}
.van-nav-bar {
  z-index: 99999;
}
.tabs {
  margin-top: 120px;
}

.van-icon {
  margin-right: 0.6rem;
  color: #4090FA;
}

.icon {
  margin-left: 1rem;
}
</style>
